import Instrument from "../Instrument";

class SquareWaveSynth extends Instrument {

	constructor(path) {
		super("SquareWaveSynth", SquareWaveSynth.nice_name, path);

		this.createParameter("octave", {
			min: -1,
			max: 4,
			default: 1,
			lock_step: true
		});

		this.createParameter("attack", {
			min: 0,
			max: 1,
			step: 0.01,
			default: 0.01
		});

		this.createParameter("decay", {
			min: 0,
			max: 1,
			step: 0.01,
			default: 0.01
		});

		this.createParameter("release", {
			min: 0,
			max: 1,
			step: 0.01,
			default: 0.025
		});

		this.createParameter("sustain", {
			min: 0,
			max: 1,
			step: 0.1,
			default: 0.8
		});

		this.createParameter("hold", {
			min: 0,
			max: 1,
			step: 0.01,
			default: 0.7
		});

	}

	scheduleNote(notes, time, tonic, scale) {

		if(typeof notes[0] === "undefined") return false;

		var attackTime = this.getParameterByName('attack').value;
		var decayTime = this.getParameterByName('decay').value;
		var sustainLevel = this.getParameterByName('sustain').value;
		var releaseTime = this.getParameterByName('release').value;
		var hold = this.getParameterByName('hold').value;

		this.frequency.setValueAtTime(this.getNoteFrequency(tonic, scale, this.getParameterByName('octave').value, notes[0]), time);


		this.gainParam.cancelScheduledValues(time);
		this.gainParam.setValueAtTime(0, time);
		this.gainParam.linearRampToValueAtTime(1, time + attackTime);
		this.gainParam.linearRampToValueAtTime(sustainLevel, time + attackTime + decayTime);
		this.gainParam.linearRampToValueAtTime(sustainLevel, time + attackTime + decayTime + hold);
		this.gainParam.linearRampToValueAtTime(0, time + attackTime + decayTime + hold + releaseTime);
	}

	createNodes(context) {
		var oscillator = context.createOscillator();

		oscillator.type = 'square';
		oscillator.start();

		var gainNode = context.createGain();

		gainNode.gain.value = 0;

		oscillator.connect(gainNode);

		this.gainParam = gainNode.gain;
		this.frequency = oscillator.frequency;

		return {
			connect: (node) => {
				gainNode.connect(node);
			},
			disconnect: (node) => {
				gainNode.disconnect(node);
			}
		};

	}
}

SquareWaveSynth.nice_name = 'Square Wave Synth';

export default SquareWaveSynth;
